import { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { authContext } from "./contexts/AuthProvider";
import { dataContext } from "./contexts/DataProvider";
import { errorContext } from "./contexts/ErrorProvider";
import ProcessData from "./utils/ProcessData";
import validate from "./validation/validator";
import {
  forgotPasswordSchema,
  forgotPasswordEmailCodeSchema,
  forgotPasswordResetSchema,
} from "./validation/schema";
import {
  forgotPasswordSendEmailCode,
  forgotPasswordVerifyEmailCode,
  forgotPasswordResetPassword,
} from "./services/authService";
import Loader from "./layout/Loader";

const ForgotPassword = () => {
  const [step, setStep] = useState("send-verification-code");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useContext(dataContext);
  const [errors, setErrors] = useContext(errorContext);
  const [isAuth] = useContext(authContext);
  const navigate = useNavigate();

  const sendEmailCode = async () => {
    const validation = validate(data, setErrors, forgotPasswordSchema());
    if (validation === true) {
      setIsLoading(true);
      const response = await forgotPasswordSendEmailCode(data);
      setIsLoading(false);
      if (response.data.code === 0) {
        setErrors({
          ...errors,
          email: response.data.message,
        });
      } else if (response.data.code === 1) {
        setStep("verify-code");
      }
    }
  };

  const verifyEmailCode = async () => {
    const validation = validate(
      data,
      setErrors,
      forgotPasswordEmailCodeSchema()
    );
    if (validation === true) {
      setIsLoading(true);
      const response = await forgotPasswordVerifyEmailCode(data);
      setIsLoading(false);
      if (response.data.code === 0) {
        setErrors({
          ...errors,
          otp: response.data.message,
        });
      } else if (response.data.code === 1) {
        setData({
          ...data,
          otp: response.data.data,
        });
        setStep("reset-password");
      }
    }
  };

  const resetPassword = async () => {
    const validation = validate(data, setErrors, forgotPasswordResetSchema());
    if (validation === true) {
      setIsLoading(true);
      const response = await forgotPasswordResetPassword(data);
      setIsLoading(false);
      if (response.data.code === 0) {
        setErrors({
          ...errors,
          confirmPassword: response.data.message,
        });
      } else if (response.data.code === 1) {
        navigate("/");
      }
    }
  };

  useEffect(() => {
    if (isAuth === true) {
      navigate("/dashboard");
    }
  }, [isAuth, navigate]);
  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="container">
      <div className="row justify-content-center align-items-center authentication authentication-basic h-100">
        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12">
          <div className="card custom-card my-4">
            <div className="card-body p-5">
              <div className="mb-4 d-flex justify-content-center">
                <Link to={`/`}>
                  <img
                    src="assets/images/brand-logos/desktop-logo.png"
                    alt="logo"
                    className="desktop-logo"
                  />
                  <img
                    src="assets/images/brand-logos/desktop-white.png"
                    alt="logo"
                    className="desktop-white"
                  />
                </Link>
              </div>
              <p className="h5 mb-2 text-center">Forgot Password</p>
              <p className="text-muted mb-4 text-center">
                Let's reset your password
              </p>
              {step === "send-verification-code" ? (
                <>
                  <div className="row gy-3">
                    <div className="col-xl-12 mb-2">
                      <label
                        htmlFor="signin-username"
                        className="form-label text-default"
                      >
                        User Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="signin-username"
                        placeholder="user name"
                        autoComplete="off"
                        value={data?.email ?? ""}
                        onChange={(e) => {
                          ProcessData(
                            data,
                            setData,
                            e,
                            "string",
                            "email",
                            errors,
                            setErrors
                          );
                        }}
                      />
                      <small className="text-danger">
                        {errors?.email ?? ""}
                      </small>
                    </div>
                  </div>
                  <div className="d-grid mt-3">
                    <button onClick={sendEmailCode} className="btn btn-primary">
                      Send Verification Code
                    </button>
                  </div>
                </>
              ) : (
                ""
              )}

              {step === "verify-code" ? (
                <>
                  <div className="row gy-3">
                    <div className="col-xl-12 mb-2">
                      <label
                        htmlFor="signin-username"
                        className="form-label text-default"
                      >
                        Verification Code
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="signin-username"
                        placeholder="Enter 6 digit verification code"
                        autoComplete="off"
                        value={data?.otp ?? ""}
                        onChange={(e) => {
                          ProcessData(
                            data,
                            setData,
                            e,
                            "string",
                            "otp",
                            errors,
                            setErrors
                          );
                        }}
                      />
                      <small className="text-danger">{errors?.otp ?? ""}</small>
                    </div>
                  </div>
                  <div className="d-grid mt-3">
                    <button
                      onClick={verifyEmailCode}
                      className="btn btn-primary"
                    >
                      Verify Email
                    </button>
                  </div>
                </>
              ) : (
                ""
              )}

              {step === "reset-password" ? (
                <>
                  <div className="row gy-3">
                    <div className="col-xl-12">
                      <label
                        htmlFor="signin-password"
                        className="form-label text-default d-block"
                      >
                        Password
                      </label>
                      <div className="position-relative">
                        <input
                          type={showPassword ? `text` : `password`}
                          className="form-control create-password-input"
                          id="signin-password"
                          placeholder="new password"
                          autoComplete="off"
                          value={data?.password ?? ""}
                          onChange={(e) => {
                            ProcessData(
                              data,
                              setData,
                              e,
                              "string",
                              "password",
                              errors,
                              setErrors
                            );
                          }}
                        />
                        <span
                          onClick={() => {
                            setShowPassword(!showPassword);
                          }}
                          className="show-password-button text-muted"
                          id="button-addon2"
                        >
                          <i
                            className={
                              showPassword
                                ? `ri-eye-line align-middle`
                                : `ri-eye-off-line align-middle`
                            }
                          ></i>
                        </span>
                      </div>
                      <small className="text-danger">
                        {errors?.password ?? ""}
                      </small>
                    </div>
                    <div className="col-xl-12 mb-2">
                      <label
                        htmlFor="signin-password"
                        className="form-label text-default d-block"
                      >
                        Confirm Password
                      </label>
                      <div className="position-relative">
                        <input
                          type={showConfirmPassword ? `text` : `password`}
                          className="form-control create-password-input"
                          id="signin-password"
                          placeholder="confirm new password"
                          autoComplete="off"
                          value={data?.confirmPassword ?? ""}
                          onChange={(e) => {
                            ProcessData(
                              data,
                              setData,
                              e,
                              "string",
                              "confirmPassword",
                              errors,
                              setErrors
                            );
                          }}
                        />
                        <span
                          onClick={() => {
                            setShowConfirmPassword(!showConfirmPassword);
                          }}
                          className="show-password-button text-muted"
                          id="button-addon2"
                        >
                          <i
                            className={
                              showConfirmPassword
                                ? `ri-eye-line align-middle`
                                : `ri-eye-off-line align-middle`
                            }
                          ></i>
                        </span>
                      </div>
                      <small className="text-danger">
                        {errors?.confirmPassword ?? ""}
                      </small>
                    </div>
                  </div>
                  <div className="d-grid mt-3">
                    <button onClick={resetPassword} className="btn btn-primary">
                      Reset Password
                    </button>
                  </div>
                </>
              ) : (
                ""
              )}

              <div className="row d-block mt-3 text-center">
                <Link to={`/`} className="text-primary fw-medium">
                  Remember password ?
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
